<template>
  <div class="full">
    <NameHeader></NameHeader>
    <router-view></router-view> 
    <NameFooter></NameFooter>
  </div>
</template>

<script>
// @ is an alias to /src
import NameHeader from "@/components/NameHeader.vue";
import NameFooter from "@/components/NameFooter.vue";

export default {
  name: "home",
  components: {
    NameHeader,
    NameFooter,
  }
};
</script>
<style scoped lang="scss">
.full {
  // overflow-x: hidden;
}
</style>
